import PlpTopBar from "./PlpTopBar";

export default PlpTopBar;
